import styled from 'styled-components';
import { Palette } from 'core/config';

export const Paragraph = styled.p`
    padding-left: 60px;
    padding-right: 60px;
    font: normal normal normal 10px 'SofiaPro-Regular';
    color: ${Palette.BLUE};
    font-weight: 200;
    line-height: 18px;

    a {
        color: ${Palette.BLUE};
        font: normal normal normal 10px 'SofiaPro-Bold';
        text-decoration: underline;
        cursor: pointer;
    }

    @media only screen and (min-width: 1300px) {
        font-size: 12px;
        span { font-size: 12px; }
        a { font-size: 12px; }
    }

    @media only screen and (min-width: 1900px) {
        font-size: 14px;
        span { font-size: 14px; }
        a { font-size: 14px;  }
    }
`;
